import { render } from "./UpdatesComp.vue?vue&type=template&id=12eb7c74&scoped=true"
import script from "./UpdatesComp.vue?vue&type=script&lang=js"
export * from "./UpdatesComp.vue?vue&type=script&lang=js"

import "./UpdatesComp.vue?vue&type=style&index=0&id=12eb7c74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12eb7c74"]])

export default __exports__